import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Radio,
  Typography,
} from "@mui/material";
import { useAssessmentStore } from "../../stores/assessmentStore";
import {
  dialogContentStyles,
  dialogPaperStyles,
  dialogTitleStyles,
  errorTextStyles,
  goButtonStyles,
  optionStyles,
  optionTitleStyles,
} from "./styles";

export const AssessmentListModal: React.FC = () => {
  const {
    availableAssessments,
    isAssessmentListOpen,
    assessmentListLoading,
    error,
    closeAssessmentList,
    requestAssessmentSend,
    setError,
  } = useAssessmentStore();
  const [selectedId, setSelectedId] = useState<string>("");

  useEffect(() => {
    if (!isAssessmentListOpen) {
      setSelectedId("");
      return;
    }
    setSelectedId((prev) => {
      if (prev && availableAssessments.some((item) => item.assessment_id === prev)) {
        return prev;
      }
      return availableAssessments[0]?.assessment_id ?? "";
    });
  }, [isAssessmentListOpen, availableAssessments]);

  const handleClose = () => {
    if (assessmentListLoading) {
      return;
    }
    setError(null);
    closeAssessmentList();
  };

  const handleStart = async () => {
    if (!selectedId || assessmentListLoading) {
      return;
    }
    await requestAssessmentSend(selectedId);
  };

  return (
    <Dialog
      open={isAssessmentListOpen}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: dialogPaperStyles }}
    >
      <DialogTitle sx={dialogTitleStyles}>
        Choose a Mastery Contest
      </DialogTitle>
      <DialogContent sx={dialogContentStyles}>
        {availableAssessments.map((item) => {
          const isSelected = selectedId === item.assessment_id;
          return (
            <Box
              key={item.assessment_id}
              sx={optionStyles(isSelected)}
              role="button"
              tabIndex={0}
              onClick={() => {
                if (!assessmentListLoading) {
                  setSelectedId(item.assessment_id);
                }
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  if (!assessmentListLoading) {
                    setSelectedId(item.assessment_id);
                  }
                }
              }}
            >
              <Radio
                checked={isSelected}
                size="small"
                disabled={assessmentListLoading}
                sx={{ p: 0.5 }}
              />
              <Typography sx={optionTitleStyles} title={item.title} noWrap>
                {item.title}
              </Typography>
            </Box>
          );
        })}

        {error ? <Typography sx={errorTextStyles}>{error}</Typography> : null}

        <Button
          variant="contained"
          fullWidth
          disabled={!selectedId || assessmentListLoading}
          onClick={handleStart}
          sx={goButtonStyles}
        >
          {assessmentListLoading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Go"
          )}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default AssessmentListModal;
